"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgHeart = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M35.452 20.5a6.5 6.5 0 01-1.905 4.597l-8.84 8.84a1 1 0 01-1.414 0l-8.84-8.84a6.501 6.501 0 019.194-9.194l.353.353.353-.353A6.5 6.5 0 0135.452 20.5zM24 31.816l7.073-7.073 1.06-1.06a4.5 4.5 0 00-3.183-7.685 4.5 4.5 0 00-3.183 1.32l-1.06 1.06a1 1 0 01-1.414 0l-1.06-1.06a4.501 4.501 0 00-6.366 6.365L24 31.816z",
    id: "heart_svg__a"
  }));
};

var _default = SvgHeart;
exports.default = _default;